import React from 'react';
import { motion } from 'framer-motion';

const Philosophy = () => {
  return (
    <section id="metodo" className="py-32 bg-black border-y border-white/5">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-7xl font-black text-white mb-12 tracking-tighter uppercase leading-none">
            PERCHÉ <span className="text-gold-500">BL.PERFORMANCE</span>?
          </h2>
          <div className="space-y-8 text-xl text-gray-300 font-bold leading-relaxed tracking-tight">
            <p>
              BLPerformance nasce dall’idea che allenarsi non significhi solo fare fatica, ma capire davvero come funziona il corpo e lavorare in modo intelligente.
            </p>
            <p>
              I miei percorsi sono costruiti su misura, integrando allenamenti in palestra, programmazione online e sessioni sul campo, a seconda delle esigenze e degli obiettivi di ciascuno.
            </p>
            <p className="text-3xl md:text-5xl text-white font-black py-12 border-y border-white/10 my-12 uppercase leading-[0.9] tracking-tighter">
              "Costruire un corpo <br className="hidden md:block" /> efficiente, sano <br className="hidden md:block" /> e funzionale."
            </p>
            <p className="text-gray-500 uppercase text-sm tracking-widest font-black">
              Studio • Esperienza pratica • Metodo strutturato
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Philosophy;